module.exports = __webpack_public_path__ + "img/banner-certificate.1d778543.png";